import YFormShareQrCode from './ShareQrCode';

export { YFormShareQrCode };
export default YFormShareQrCode;
